import React from 'react';
import TRANSLATIONS from '../../translations/translations@default.json';

export const Switch24BannerTerms = (props: { UseLineBreak: boolean }) => {
	const { UseLineBreak } = props;

	const origin = window.location.origin;
	const membershipTermsUrl = `${origin}/help-and-advice/finance-and-savings/ao-five-star/t-and-cs`;
	const switchTermsUrl = `${origin}/mobile-phones/switch24/tandcs`;

	return (
		<>
			<span>
				{' '}
				{TRANSLATIONS.listerFooter.financeExample.membershipDisclaimerText}
			</span>
			{UseLineBreak && <br />}
			<span>
				{' '}
				<a className="text-link" href={membershipTermsUrl}>
					Membership terms
				</a>{' '}
				and{' '}
				<a className="text-link" href={switchTermsUrl}>
					Switch24 terms
				</a>{' '}
				apply.
			</span>
		</>
	);
};
